<template>
  <router-view />
</template>
<script>

export default {
  name: 'RouteView',
  data() {
    return {
    }
  },
  computed: {
    keepAliveListIncludeNames() {
      return this.$store.getters.keepAliveListIncludeNames
    },
    keepAlive() {
      return this.$route.meta.keepAlive
    }
  }
}
</script>
